import { render, staticRenderFns } from "./TotalAmount.vue?vue&type=template&id=662345ba&scoped=true"
import script from "./TotalAmount.vue?vue&type=script&lang=js"
export * from "./TotalAmount.vue?vue&type=script&lang=js"
import style0 from "./TotalAmount.vue?vue&type=style&index=0&id=662345ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662345ba",
  null
  
)

export default component.exports